import { render, staticRenderFns } from "./PrizesScreen.vue?vue&type=template&id=a88e412c&"
import script from "./PrizesScreen.vue?vue&type=script&lang=js&"
export * from "./PrizesScreen.vue?vue&type=script&lang=js&"
import style0 from "./PrizesScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports